import React from 'react'

const Photo = (photo) => 
{
  const { urls, alt_description, likes, user } = photo;
  const { regular } = urls;
  const { name, portfolio_url, profile_image } = user;
  const { medium } = profile_image;

  return (
    <article className = 'photo'>
      <img src={regular} alt={alt_description} />
      <div className = "photo-info">
       <div>
         <h4>{name}</h4>
         <p>{likes} Likes</p>
       </div>
       <a href= {portfolio_url}><img src={medium} alt={name} className = 'user-img'/></a>
      </div>
    </article>);
}

export default Photo
